<template>
  <div
    class="tw-absolute tw-z-30 tw-top-2 tw-right-2 tw-flex tw-items-center tw-gap-2"
    @click.stop
  >
    <!-- QR Code -->
    <div
      class="tw-bg-white tw-shadow-lg tw-rounded-md tw-p-1.5 tw-flex tw-flex-col tw-items-center"
    >
      <canvas ref="qrCanvas"></canvas>
    </div>

    <!-- Botão -->
    <button
      class="tw-px-4 tw-py-2 tw-bg-white tw-shadow-lg tw-font-semibold tw-justify-center tw-items-center tw-flex tw-rounded-md tw-text-base"
      @click.stop="openPrivacyPopup"
    >
      <v-icon color="#8c2667" size="22">mdi-shield-account</v-icon>
      <div class="tw-ml-1.5">Política de Privacidade</div>
    </button>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  mounted() {
    QRCode.toCanvas(
      this.$refs.qrCanvas,
      "https://mobile.photonow.com.br/politica-de-privacidade",
      {
        width: 65,
        margin: 1,
      }
    );
  },
  methods: {
    openPrivacyPopup() {
      this.$emit("open-privacy-popup");
    },
  },
};
</script>
